__webpack_require__.p = "/balayagebygigisalon/";